// extracted by mini-css-extract-plugin
module.exports = {"collapse":"_2Qryk","on":"_3ixLE","off":"_3Ji5O","collapseCon":"_2xrOA"};